/**
 * Just a dump UI component for displaying a nice looking Dialer.
 */
(function () {
    angular.module('tradersyard').component('tyCallDialer', {
        // language=HTML
        template:
            '<div class="ty-call-dialer">\n\n    <div ng-if="$ctrl.isConnecting()">\n        <div class="modal-body">\n            <div class="caller rejected">\n                <strong>Connecting to</strong>\n                <span class="caller-name">{{ $ctrl.userName }}</span>\n                <span class="caller-image"><img ng-src="{{$ctrl.userImage}}" alt=""></span>\n            </div>\n        </div>\n        <div class="modal-footer">\n            <button class="btn btn-primary" type="button" ng-click="$ctrl.closeModal()">\n                <i class="fa fa-times"></i>\n            </button>\n        </div>\n    </div>\n    \n    <div ng-if="$ctrl.isCalling()">\n        <div class="modal-body">\n            <div class="caller calling">\n                <span ng-if="$ctrl.isOutgoingCall">Calling </span>\n                <span class="caller-name">{{ $ctrl.userName }}</span>\n                <span ng-if="$ctrl.isIncomingCall">is calling you</span>\n                <span class="caller-image"><img ng-src="{{$ctrl.userImage}}" alt=""></span>\n            </div>\n        </div>\n        \n        <div class="modal-footer" ng-if="$ctrl.isOutgoingCall">\n            <button class="btn btn-danger" type="button" ng-click="$ctrl.endCall()">\n                <i class="fa fa-times"></i>\n            </button>\n        </div>\n\n        <div class="modal-footer" ng-if="$ctrl.isIncomingCall">\n            <button class="btn btn-success" type="button" ng-click="$ctrl.acceptCall()">\n                <i class="fa fa-phone"></i>\n            </button>\n            <button class="btn btn-danger" type="button" ng-click="$ctrl.rejectCall()">\n                <i class="fa fa-times"></i>\n            </button>\n        </div>\n        \n    </div>\n    \n    <!-- region TIMEOUT -->\n    <div ng-if="$ctrl.isTimeout()">\n        <div class="modal-body">\n            <div class="caller rejected">\n                <strong>You missed the call from</strong>\n                <span class="caller-name">{{ $ctrl.userName }}</span>\n                <span class="caller-image"><img ng-src="{{$ctrl.userImage}}" alt=""></span>\n            </div>\n        </div>\n        <div class="modal-footer">\n            <button class="btn btn-primary" type="button" ng-click="$ctrl.closeModal()">\n                <i class="fa fa-times"></i>\n            </button>\n        </div>\n    </div>\n    <!-- endregion -->\n\n    <div ng-if="$ctrl.isRejected() || $ctrl.isEnded()">\n        <div class="modal-body">\n            <div class="caller rejected">\n                <span class="caller-name">{{ $ctrl.userName }}</span>\n                <strong ng-show="$ctrl.isRejected()">rejected your call</strong>\n                <strong ng-show="$ctrl.isEnded()">your call ended</strong>\n                <span class="caller-image"><img ng-src="{{$ctrl.userImage}}" alt=""></span>\n            </div>\n        </div>\n        <div class="modal-footer">\n            <button class="btn btn-primary" type="button" ng-click="$ctrl.closeModal()">\n                <i class="fa fa-times"></i>\n            </button>\n        </div>\n    </div>\n    \n</div>\n',
        bindings: {
            meetingId: '<',
            callType: '<',
            callStatus: '<',
            userName: '<',
            userImage: '<',
            onAccept: '&',
            onReject: '&',
            onEndCall: '&',
            onClose: '&',
        },
        controller: CallDialerCtrl,
    });

    CallDialerCtrl.$inject = ['CallService'];

    var RINGTONE_INCOMING_SRC = '/sounds/incoming_call.mp3';
    var RINGTONE_OUTGOING_SRC = '/sounds/outgoing_call.mp3';

    function CallDialerCtrl(CallService) {
        var ctrl = this;

        ctrl.isIncomingCall = false;
        ctrl.isOutgoingCall = false;

        ctrl.isConnecting = function () {
            return ctrl.callStatus === 'connecting';
        };
        ctrl.isCalling = function () {
            return ctrl.callStatus === 'calling';
        };
        ctrl.isRejected = function () {
            return ctrl.callStatus === 'rejected';
        };
        ctrl.isEnded = function () {
            return ctrl.callStatus === 'ended';
        };
        ctrl.isTimeout = function () {
            return ctrl.callStatus === 'timeout';
        };

        ctrl.acceptCall = acceptCall;
        ctrl.rejectCall = rejectCall;
        ctrl.endCall = endCall;
        ctrl.closeModal = closeModal;

        ctrl.$onInit = $onInit;
        ctrl.$onChanges = $onInit;
        ctrl.$onDestroy = $onDestroy;

        ctrl.ringtone = undefined;

        // region: implementation

        function $onInit() {
            initializeComponent({ callType: ctrl.callType });
        }

        function $onDestroy() {
            stopRingtone();
        }

        function acceptCall() {
            ctrl.onAccept();
        }

        function rejectCall() {
            ctrl.onReject();
        }

        function endCall() {
            ctrl.onEndCall();
        }

        function closeModal() {
            ctrl.onClose();
        }

        // endregion

        /**
         * @param {object} params
         * @private
         */
        function initializeComponent(params) {
            ctrl.isIncomingCall = params.callType === CallService.CALL_INCOMING;
            ctrl.isOutgoingCall = params.callType === CallService.CALL_OUTGOING;

            ctrl.isCalling() ? withRingtone() : noRingtone();
        }

        // region Ringtone control

        function withRingtone() {
            var ringtoneSrc = ctrl.isIncomingCall ? RINGTONE_INCOMING_SRC : RINGTONE_OUTGOING_SRC;

            stopRingtone();
            setRingtone(ringtoneSrc);
            startRingtone();
        }

        function noRingtone() {
            stopRingtone();
        }

        function setRingtone(src) {
            ctrl.ringtone = new Audio(src);
            ctrl.ringtone.loop = true;
        }

        function startRingtone() {
            return ctrl.ringtone && ctrl.ringtone.play();
        }

        function stopRingtone() {
            return ctrl.ringtone && ctrl.ringtone.pause();
        }

        // endregion
    }

    /**
     * Return a looped ringtone audio
     * @param {string} src File source relative to `public` folder
     * @returns {HTMLAudioElement}
     */
    function setupRingtoneAudio(src) {
        var ring = new Audio(src);
        ring.loop = true;
        return ring;
    }
})();
